module.exports = __webpack_public_path__ + "static/media/close-right.fceabb7b.svg";